import { PhaserButton, PhaserButtonConfig } from 'src/games/shared/Button';
import { PhaserModal, PhaserModalConfig, ModalOption } from 'src/games/shared/Modal';
import { ModalTitleOption, PhaserModalTitle, PhaserModalTitleConfig } from '../../../shared/ModalTitle';

export class MainScene extends Phaser.Scene {

    constructor() {
        super({
            key: "MainScene", active: true
        });
    }

    preload(): void {
        this.load.image('pixel', require('src/assets/qci/sprites/pixel.png'));
    }

    create(): void {
        // Add a button to launch a modal with some options
        var buttonConfig = new PhaserButtonConfig();
        buttonConfig.backgroundColor = 0xff0000;
        var button = new PhaserButton(this, this.cameras.main.width - 200, 50, 150, 50, "Click To Open Modal", buttonConfig);
        button.setDepth(200);
        // Set button onClick handler
        button.on('buttonClicked', (pointer: Phaser.Input.Pointer, x: number, y: number) => {
            var modalConfig = new PhaserModalConfig();
            modalConfig.title = "This is a modal!";
            // Override the default title and button colors
            modalConfig.buttonConfig = new PhaserButtonConfig();
            modalConfig.buttonConfig.smartSize = true;
            modalConfig.buttonConfig.backgroundColor = 0x4286f4;

            // Options are essentially buttons
            var modalOptions = [
                { id: 1, displayText: "Change Modal Position" }, // Can also add a reference to an object here
                { id: 2, displayText: "Add Text To Scene" },
                { id: 3, displayText: "Close Modal" },

            ];
            // Create modal with 3 options
            var modal = new PhaserModal(this, this.cameras.main.width / 2, this.cameras.main.height / 2, modalOptions, modalConfig);
            modal.setDepth(200);
            // Set option onClick handler
            modal.on('optionClicked', (option: ModalOption) => {
                if (option.id === 1) {
                    modal.setRandomPosition(0, 0, 500, 500);
                }
                else if (option.id === 2) {
                    console.log(option);
                    // Do something custom here... (e.g. change some game state or the scene)
                    this.add.text(0, 0, "Just Added This To The Scene!").setRandomPosition(0, 0, 500, 500);
                }
                else {
                    modal.destroy();
                }
            });
        });


        var background = this.add.image(0, 0, "pixel");
        background.setOrigin(0);
        background.setDisplaySize(this.cameras.main.width, this.cameras.main.height);

        var config = new PhaserModalTitleConfig();
        config.title = "This is the Title make it a long title for this example to see what it does in this case";
        config.bodyText = "Some jobs need special training, or certificates, (also called credentials) in order for a person to work in a specific job. Some workers need to be certified or licensed in order to show employers and customers that they are qualified to do the work. This means that workers have studied and taken exams to show that they are dedicated and interested in learning about their work. Credentials and certifications also help a worker stay up-to-date on any new information that is important to their job.";
        config.borderColor = 0xff0000;
        config.buttonWidth = 100;

        var button2 = new PhaserButton(this, this.cameras.main.width - 400, 50, 150, 50, "Click To Open Title Modal");
        button2.setDepth(200);
        button2.on('buttonClicked', () => {
            var titleModal = new PhaserModalTitle(this, 100, 100, config, [{ id: 1, displayText: "button" }]);
            titleModal.on('optionClicked', () => titleModal.destroy());
        });
    }
}



// WEBPACK FOOTER //
// ./src/games/demos/modalButtonComponentDemo/scenes/MainScene.ts